import { Component, inject } from '@angular/core';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import {
    AccessType,
    AuthService,
    EmptyCheckInGridViewDto,
    EmptyCheckInStatus,
    PermissionType,
    ShuntLocationType,
} from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { CommonModule, NgClass } from '@angular/common';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Router, RouterLink } from '@angular/router';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { EmptyCheckInStatusPipe } from 'src/app/pipes/empty-check-in-status.pipe';
import { CapitalCasePipe } from 'src/app/pipes/capital-case.pipe';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';

@Component({
    selector: 'app-empty-check-ins',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxButtonComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        NgClass,
        FilterPanelComponent,
        DxFormComponent,
        RouterLink,
        EmptyCheckInStatusPipe,
        CapitalCasePipe,
        UserAvatarEmailComponent,
    ],
    providers: [EmptyCheckInStatusPipe],
    templateUrl: './empty-check-ins.component.html',
})
export class EmptyCheckInsComponent extends GridPageComponent<EmptyCheckInGridViewDto> {
    private router = inject(Router);
    private emptyCheckInStatusPipe = inject(EmptyCheckInStatusPipe);
    private authService = inject(AuthService);

    protected override exportName: string = 'Empty Check-Ins Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.emptyCheckIns();

    statusOptions = EnumUtils.getEnumOptions(EmptyCheckInStatus, (v) =>
        this.emptyCheckInStatusPipe.transform(v),
    );
    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType);

    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        { field: 'number', op: 'contains' },
        { field: 'carrier', op: 'contains' },
        { field: 'trailerNumber', op: 'contains' },
        { field: 'location', op: '=' },
        { field: 'shuntLocationNumber', op: 'contains' },
        { field: 'status', op: '=' },
        { field: 'created', op: '>=' },
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
    ];

    constructor() {
        super();
        this.init(EmptyCheckInGridViewDto);
    }

    protected getBadgeClass(status: EmptyCheckInStatus): string {
        return EnumUtils.getEmptyCheckInStatusBadgeClass(status);
    }

    addEmptyCheckIn = async () => {
        await this.router.navigate(['/inbound/empty-check-ins/create']);
    };

    async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        await this.router.navigate([
            `/inbound/empty-check-ins/details/${e.data.number}`,
        ]);
    }

    get canCreate(){
        return this.authService.checkPermission(PermissionType.EmptyCheckIns, AccessType.Manage);
    }
}
